import fetch from './fetch'
import create from './create'
import update from './update'
import del from './delete'
import uploadPictograms from './uploadPictograms'

import fetchColonies from './fetchColonies'
import fetchSupply from './fetchSupply'

export default {
  fetch,
  create,
  update,
  delete: del,
  fetchColonies,
  fetchSupply,
  uploadPictograms
}


// WEBPACK FOOTER //
// ./src/services/catalog/index.js